import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";




function OfflineToast() {
  const [isOnline, setIsOnline] = useState(true);
  const [showReconnected, setShowReconnected] = useState(false);
  const wasOffline = useRef(false);
    const { t, i18n } = useTranslation();

  useEffect(() => {
    // Check connection by trying to fetch a small resource
    const checkConnection = async () => {
      try {
        // Try to fetch from multiple sources for reliability
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        await fetch("https://www.google.com/favicon.ico", {
          mode: "no-cors",
          signal: controller.signal,
          cache: "no-store",
        });

        clearTimeout(timeoutId);

        // We're online
        if (wasOffline.current) {
          setIsOnline(true);
          setShowReconnected(true);
          setTimeout(() => setShowReconnected(false), 3000);
          wasOffline.current = false;
        } else {
          setIsOnline(true);
        }
      } catch (error) {
        // We're offline
        setIsOnline(false);
        wasOffline.current = true;
      }
    };

    // Initial check
    checkConnection();

    // Check every 5 seconds
    const interval = setInterval(checkConnection, 5000);

    // Also listen to browser events as backup
    const handleOnline = () => checkConnection();
    const handleOffline = () => {
      setIsOnline(false);
      wasOffline.current = true;
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      clearInterval(interval);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const toastStyle = {
    position: "fixed",
    top: "40%",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "16px 24px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: "320px",
    animation: "slideDown 0.3s ease-out",
    fontFamily: "system-ui, -apple-system, sans-serif",
  };

  const offlineStyle = {
    ...toastStyle,
    backgroundColor: "#dc2626",
    color: "white",
  };

  const onlineStyle = {
    ...toastStyle,
    backgroundColor: "#16a34a",
    color: "white",
  };

  const iconStyle = {
    width: "20px",
    height: "20px",
    flexShrink: 0,
  };

  const textContainerStyle = {
    flex: 1,
  };

  const titleStyle = {
    fontWeight: 600,
    marginBottom: "4px",
    fontSize: "14px",
  };

  const messageStyle = {
    fontSize: "13px",
    opacity: 0.9,
  };

  return (
    <>
      <style>
        {`
          @keyframes slideDown {
            from {
              transform: translate(-50%, -100%);
              opacity: 0;
            }
            to {
              transform: translate(-50%, 0);
              opacity: 1;
            }
          }
        `}
      </style>

      {!isOnline && (
        <div style={offlineStyle}>
          <svg
            style={iconStyle}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3"
            />
          </svg>
          <div style={textContainerStyle}>
            <div style={titleStyle}>{t('offline')}</div>
            <div style={messageStyle}>{t("offline_message")}</div>
          </div>
        </div>
      )}

      {isOnline && showReconnected && (
        <div style={onlineStyle}>
          <svg
            style={iconStyle}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
            />
          </svg>
          <div style={textContainerStyle}>
            <div style={titleStyle}>{t("online")}</div>
            <div style={messageStyle}>{t("online_message")}</div>
          </div>
        </div>
      )}
    </>
  );
}

export default OfflineToast;
